import { styled } from '@glitz/react';
import * as style from '../Style';

export default styled.h1({
  fontSize: style.alpha,
  fontWeight: 'normal',
});
